var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageAdd = function SvgMessageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 2v2H5a1 1 0 0 0-1 1v13.586l2.293-2.293A1 1 0 0 1 7 16h12a1 1 0 0 0 1-1v-2h2v2a3 3 0 0 1-3 3H7.414l-3.707 3.707A1 1 0 0 1 2 21V5a3 3 0 0 1 3-3zm8 0a3 3 0 0 1 3 3v4h-2V5a1 1 0 0 0-1-1h-4V2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.65 2c.746 0 1.35.604 1.35 1.35v6.3A1.35 1.35 0 0 1 20.65 11h-6.3A1.35 1.35 0 0 1 13 9.65v-6.3c0-.746.604-1.35 1.35-1.35zM17.5 4a.5.5 0 0 0-.5.5V6h-1.5a.5.5 0 0 0 0 1H17v1.5a.5.5 0 0 0 1 0V7h1.5a.5.5 0 0 0 0-1H18V4.5a.5.5 0 0 0-.5-.5"
  })));
};
export default SvgMessageAdd;